import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook para manejar vinculación/desvinculación de leads
 * @param {Object} detallesLead - Detalles del lead actual
 * @param {Function} setDetallesLead - Actualiza detalles del lead
 * @param {Array} contactos - Lista de contactos
 * @param {Function} setContactos - Actualiza contactos
 * @param {Function} GuardarComentario - Guarda comentarios
 * @param {Function} guardarNotificacion - Guarda notificaciones
 * @param {Function} crearObjAction - Crea objeto de acción
 * @returns {Object} Estados y funciones para vinculación de leads
 */
export const useLeadVinculation = (detallesLead, setDetallesLead, contactos, setContactos, GuardarComentario, guardarNotificacion, crearObjAction) => {
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const { showErrorToast } = useToast();

    const [habilitarVinculacion, setHabilitarVinculacion] = useState(0);
    const [idLeadVincular, setIdLeadVincular] = useState("");
    const [procesandoVincular, setProcesandoVincular] = useState(false);
    const [procesandoDesvincular, setProcesandoDesvincular] = useState(false);
    const [procesandoDesvincularLeadCliente, setProcesandoDesvincularLeadCliente] = useState(false);

    const vincularLead = async (leadsVinculados, setLeadsVinculados, setListaJsonLeadsVinculados) => {
        setProcesandoVincular(true);
        var jDataSend = {
            idLeadVincular: idLeadVincular,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/vincularLead/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);
                var ObjDetalles = detalles['table2'][0];
                var ObjLeads = JSON.parse(ObjDetalles.vJsonLeadsVinculados);
                const newArray = ObjLeads.filter(e => e.idLead !== detallesLead.idLead);

                setListaJsonLeadsVinculados(newArray);

                if (leadsVinculados !== null && typeof leadsVinculados !== 'undefined') {
                    setLeadsVinculados(detalles['table3']);
                }

                setHabilitarVinculacion(0);

                GuardarComentario("<b class='badge badge-soft-info' >Se vinculo al Lead #" + idLeadVincular + "</b>", 2, detallesLead.idLead);
                GuardarComentario("<b class='badge badge-soft-info' >Se vinculo al Lead #" + detallesLead.idLead + "</b>", 2, idLeadVincular);

                setProcesandoVincular(false);
                setIdLeadVincular("");

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detallesLeadCopy = detallesLead;
                        detallesLeadCopy.iDaysDiff = 0;
                        setContactos([detallesLeadCopy, ...contactos]);
                    } else {
                        contactos[currentLeadIndex].iDaysDiff = 0;
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Leads vinculados",
                        "<b> " + nombreCompleto + "</b> vinculó los leads <b>#" + detallesLead.idLead + "</b> y <b> #" + idLeadVincular + "</b>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2
                    );
                }

                setDetallesLead({
                    ...detallesLead,
                    idClienteAkasia: ObjDetalles.idClienteAkasia,
                    vNombreClienteAkasia: ObjDetalles.vNombreClienteAkasia
                });
            } else {
                showErrorToast(data.vMessage);
                setProcesandoVincular(false);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            setProcesandoVincular(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const desvincularLead = async (idLeadDesvincular, leadsVinculados, setLeadsVinculados, setListaJsonLeadsVinculados) => {
        setProcesandoDesvincular(true);
        var jDataSend = {
            idLeadDesvincular: idLeadDesvincular,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/desvincularLead/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);
                var ObjLeadsVinculadosModal = JSON.parse(detalles['table2'][0]['vJsonLeadsVinculados']);
                var ObjLeadsVinculados = detalles['table3'];

                const newArray = ObjLeadsVinculadosModal.filter(e => e.idLead !== detallesLead.idLead);
                setListaJsonLeadsVinculados(newArray);
                setHabilitarVinculacion(0);

                if (leadsVinculados !== null && typeof leadsVinculados !== 'undefined') {
                    setLeadsVinculados(ObjLeadsVinculados);
                }

                GuardarComentario("<b class='badge badge-soft-danger' >Se desvinculo al Lead #" + detallesLead.idLead + "</b>", 2, idLeadDesvincular);
                GuardarComentario("<b class='badge badge-soft-danger' >Se desvinculo al Lead #" + idLeadDesvincular + "</b>", 2, detallesLead.idLead);

                setProcesandoDesvincular(false);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detallesLeadCopy = detallesLead;
                        detallesLeadCopy.iDaysDiff = 0;
                        setContactos([detallesLeadCopy, ...contactos]);
                    } else {
                        contactos[currentLeadIndex].iDaysDiff = 0;
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Leads desvinculados",
                        "<b> " + nombreCompleto + "</b> desvinculó los leads <b>#" + idLeadDesvincular + "</b> y <b> #" + detallesLead.idLead + "</b>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2
                    );
                }

                setDetallesLead({ ...detallesLead });
            } else {
                showErrorToast(data.vMessage);
                setProcesandoDesvincular(false);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            setProcesandoDesvincular(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const desvincularLeadCliente = async (listaJsonLeadsVinculados, leadsVinculados, setLeadsVinculados, obtenerComentarios) => {
        setProcesandoDesvincularLeadCliente(true);

        var objDataSend = {
            idLead: detallesLead.idLead,
            idClienteAkasia: detallesLead.idClienteAkasia
        };

        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/leads/desvincularLeadCliente/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);
                setProcesandoDesvincularLeadCliente(false);

                if (leadsVinculados !== null && typeof leadsVinculados !== 'undefined') {
                    if (detalles == null) {
                        setLeadsVinculados([]);
                    } else {
                        setLeadsVinculados(detalles['table2']);
                    }
                }

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detallesLeadCopy = { ...detallesLead };
                        detallesLeadCopy.iDaysDiff = 0;
                        detallesLeadCopy.idClienteAkasia = null;
                        detallesLeadCopy.vNombreClienteAkasia = null;
                        setContactos([detallesLeadCopy, ...contactos]);
                    } else {
                        contactos[currentLeadIndex].iDaysDiff = 0;
                        contactos[currentLeadIndex].idClienteAkasia = null;
                        contactos[currentLeadIndex].vNombreClienteAkasia = null;
                    }
                }

                if (listaJsonLeadsVinculados.length > 0) {
                    listaJsonLeadsVinculados.map((lead) => {
                        GuardarComentario("<b class='badge badge-soft-danger' >Se desvinculo al cliente</b> <b>" + detallesLead.vNombreClienteAkasia + "</b>", 2, lead.idLead);

                        if (contactos !== null && contactos !== undefined) {
                            var currentLeadIndex = contactos.findIndex((l) => l.idLead === lead.idLead);
                            if (currentLeadIndex > -1) {
                                contactos[currentLeadIndex].iDaysDiff = 0;
                            }
                        }
                    });
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cliente desvinculado",
                        "<b> " + nombreCompleto + "</b> desvinculó el lead <b>#" + detallesLead.idLead + "</b> con el cliente : <i> '" + detallesLead.vNombreClienteAkasia.substring(0, 3) + "...'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2
                    );
                }

                await GuardarComentario("<b class='badge badge-soft-danger' >Se desvinculo al cliente</b> <b>" + detallesLead.vNombreClienteAkasia + "</b>", 2, detallesLead.idLead);

                detallesLead.idClienteAkasia = null;
                detallesLead.vNombreClienteAkasia = null;

                obtenerComentarios(detallesLead.idLead);
            } else {
                showErrorToast(data.vMessage);
                setProcesandoDesvincularLeadCliente(false);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            setProcesandoDesvincularLeadCliente(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    return {
        habilitarVinculacion,
        setHabilitarVinculacion,
        idLeadVincular,
        setIdLeadVincular,
        procesandoVincular,
        procesandoDesvincular,
        procesandoDesvincularLeadCliente,
        vincularLead,
        desvincularLead,
        desvincularLeadCliente
    };
};
